dataSlider = document.querySelector('[data-carousel="swiper-carousel"]');
id = dataSlider.getAttribute('data-section-id');
const items = dataSlider.getAttribute('data-items');
var swiper = new Swiper('#swiper-' + id + '-carousel', {
  slidesPerView: items,
  spaceBetween: 30,
  //centeredSlides: true,
  navigation: {
    nextEl: ".product-carousel .swiper-button-next",
    prevEl: ".product-carousel .swiper-button-prev",
  },
  pagination: {
    el: ".product-carousel .swiper-pagination",
  },
  breakpoints: {
    "@0.00": {
      slidesPerView: 1,
      spaceBetween: 30,
    },
    "@0.75": {
      slidesPerView: 1,
      spaceBetween: 30,
    },
    "@1.00": {
      slidesPerView: 2,
      spaceBetween: 30,
    },
    "@1.50": {
      slidesPerView: items,
      spaceBetween: 30,
    },
  },
});